import { NextSeo } from 'next-seo'
import type { GetStaticPaths, GetStaticProps, GetStaticPropsContext } from 'next'
import { getPage, getPages, PostOrPage } from '@src/lib/ghost'
import { formatDate } from '@src/lib/utils'
import SiteLayout from '@src/ui/components/site-layout'

type PageProps = {
  page: PostOrPage
}
const Page = (props: PageProps) => {
  return (
    <SiteLayout>
      <NextSeo
        title={props.page.title}
        description={props.page.excerpt}
        canonical={`https://swift.cloud/legal/${props.page.slug}`}
      />
      <div className='sm:px-6 lg:pt-24 lg:pb-28 lg:px-8 relative px-4 pt-8 pb-20 bg-white'>
        <div className='max-w-7xl relative mx-auto'>
          <div className='text-center'>
            <h1 className='sm:text-5xl text-slate-900 text-3xl font-bold tracking-tight'>
              {props.page.title}
            </h1>
            <p className='text-slate-600 mt-4 text-base'>
              Last updated: {formatDate(props.page.updated_at as string)}
            </p>
          </div>
          <div className='max-w-3xl gap-5 mx-auto mt-12'>
            <div className='post' dangerouslySetInnerHTML={{ __html: props.page.html as string }} />
          </div>
        </div>
      </div>
    </SiteLayout>
  )
}

export const getStaticPaths: GetStaticPaths = async () => {
  const pages = await getPages()
  const paths = pages.map((page) => ({
    params: { slug: page.slug }
  }))
  return { paths, fallback: 'blocking' }
}

export const getStaticProps: GetStaticProps = async (context: GetStaticPropsContext) => {
  const slug = context?.params?.slug as string
  const page = await getPage(slug)
  if (!page) {
    return {
      notFound: true
    }
  }
  return {
    props: { page },
    revalidate: 1
  }
}

export default Page
